/* src/app/dialogs/confirm-dialog/confirm-dialog.component.scss */
.message {
  white-space: pre-line;
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
